// @ts-nocheck
export const TRADE_ACTIVITY = [
  {
    id: "ta-001",
    cardId: "black-lotus-magic-the-gathering",
    relatedCard: "Mox Sapphire",
    timestamp: "2026-02-05T16:20:00Z",
  },
  {
    id: "ta-002",
    cardId: "black-lotus-magic-the-gathering",
    dealSize: 2,
    timestamp: "2026-01-30T19:10:00Z",
  },
  {
    id: "ta-003",
    cardId: "charizard-vmax-pokemon",
    relatedCard: "Pikachu Illustrator",
    timestamp: "2026-02-06T12:40:00Z",
  },
  {
    id: "ta-004",
    cardId: "charizard-vmax-pokemon",
    dealSize: 3,
    timestamp: "2026-01-29T20:15:00Z",
  },
  {
    id: "ta-005",
    cardId: "blue-eyes-white-dragon-yu-gi-oh",
    relatedCard: "Dark Magician",
    timestamp: "2026-02-04T09:05:00Z",
  },
  {
    id: "ta-006",
    cardId: "pikachu-illustrator-pokemon",
    dealSize: 2,
    timestamp: "2026-01-28T14:55:00Z",
  },
  {
    id: "ta-007",
    cardId: "mox-sapphire-magic-the-gathering",
    relatedCard: "Tropical Island",
    timestamp: "2026-02-02T11:30:00Z",
  },
  {
    id: "ta-008",
    cardId: "lugia-legend-pokemon",
    relatedCard: "Rayquaza VMAX",
    timestamp: "2026-02-01T18:10:00Z",
  },
];
